import * as constants from '../constants/actions';
import * as storage from '../persistance/storage';

const initialState = {
	user: storage.get('authUser') === null ? null : JSON.parse(storage.get('authUser')),
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
  	case constants.USER_SET:
      return userSet(state, action);
    default:
      return state;
  }
}

function userSet(state, action) {
  return Object.assign({}, state, {
    user: action.user
  });
}

